/* eslint-disable no-param-reassign */
import adobexd from '../assets/images/programs_icons/adobexd.svg';
import figma from '../assets/images/programs_icons/figma.svg';
import sketch from '../assets/images/programs_icons/sketch.svg';
import invision from '../assets/images/programs_icons/invision.svg';
import protopie from '../assets/images/programs_icons/protopie.svg';
import webflow from '../assets/images/programs_icons/webflow.svg';
import axure from '../assets/images/programs_icons/axure.svg';
import framer from '../assets/images/programs_icons/framer.svg';
import marvel from '../assets/images/programs_icons/marvel.svg';
import principle from '../assets/images/programs_icons/principle.svg';
import miro from '../assets/images/programs_icons/miro.svg';
import justinmind from '../assets/images/programs_icons/justinmind.svg';
import figjam from '../assets/images/programs_icons/figjam.svg';
import jira from '../assets/images/programs_icons/jira.svg';
import googledocs from '../assets/images/programs_icons/googledocs.svg';
import adobephotoshop from '../assets/images/programs_icons/adobephotoshop.svg';
import adobeillustrator from '../assets/images/programs_icons/adobeillustrator.svg';
import adobeanimate from '../assets/images/programs_icons/adobe_animate.svg';
import autodeskmaya from '../assets/images/programs_icons/autodesk_maya.svg';
import adobefonts from '../assets/images/programs_icons/adobefonts.svg';
import procreate from '../assets/images/programs_icons/procreate.svg';
import adobeaftereffects from '../assets/images/programs_icons/adobeaftereffect.svg';
import unity from '../assets/images/programs_icons/unity.svg';
import cinema4d from '../assets/images/programs_icons/cinema4d.svg';
import blender from '../assets/images/programs_icons/blender.svg';
import adobedimension from '../assets/images/programs_icons/adobedimension.svg';
import zbrush from '../assets/images/programs_icons/zbrush.svg';
import drawio from '../assets/images/programs_icons/drawio.svg';
import zeplin from '../assets/images/programs_icons/zeplin.svg';
import claude from '../assets/images/programs_icons/claude.svg';
import lovable from '../assets/images/programs_icons/lovable.svg';
import gemini from '../assets/images/programs_icons/gemini.svg';
import stitch from '../assets/images/programs_icons/stitch.svg';
import aistudio from '../assets/images/programs_icons/aistudio.svg';
import antigravity from '../assets/images/programs_icons/antigravity.svg';
import codex from '../assets/images/programs_icons/codex.svg';
import canva from '../assets/images/programs_icons/canva.svg';
import unreal from '../assets/images/programs_icons/unreal.svg';
import aiexpert from '../assets/images/programs_icons/aiexpert.svg';
import weave from '../assets/images/programs_icons/weave.svg';

export const fitTextToString = (el) => {
  el.style.fontSize = '';

  const style = window.getComputedStyle(el);

  let height = el.clientHeight;
  let fontSize = parseInt(style.getPropertyValue('font-size'), 10);
  let lineHeight = parseInt(style.getPropertyValue('line-height'), 10);

  while (height >= lineHeight * 2) {
    fontSize -= 1;
    el.style.fontSize = `${fontSize}px`;
    height = el.clientHeight;
    lineHeight = parseInt(style.getPropertyValue('line-height'), 10);
  }
};

export const fitTextToBlock = (parent, el) => {
  parent.style.fontSize = '';

  const elStyle = window.getComputedStyle(el);
  const parentStyle = window.getComputedStyle(el);

  let elHeight = el.clientHeight;
  let parentFontSize = parseInt(parentStyle.getPropertyValue('font-size'), 10);
  let elLineHeight = parseInt(elStyle.getPropertyValue('line-height'), 10);

  while (elHeight >= elLineHeight * 2) {
    parentFontSize -= 1;
    parent.style.fontSize = `${parentFontSize}px`;
    elHeight = el.clientHeight;
    elLineHeight = parseInt(elStyle.getPropertyValue('line-height'), 10);
  }
};

// The reason why the function below exists is that at this point of time the easiest way to create content is to
// generate it as tables in the WYSIWYG editor integrated in the admin panel. It was also requested that there is
// a need to wrap cells when the site is loaded on the mobile or the browser window is resized to a small
// resolution, so each column wraps under the previous one. I've decided to generate lists out of tables and apply
// media queries to change the layout instead of running a js reordering of the table each time the
// window resize event occurs.
export const transformTablesIntoLists = (originalContent) => {
  const container = document.createElement('div');

  container.innerHTML = originalContent;

  const tables = Array.from(container.children).filter(child => child.tagName === 'TABLE');
  const lists = tables.map((table) => {
    const listEl = document.createElement('ul');
    const listItems = [];
    let cellAmount = 0;

    Array.from(table.rows).forEach((row, rowIndex) => {
      if (rowIndex === 0) cellAmount = row.cells.length;
      Array.from(row.cells).forEach((cell, cellIndex) => {
        const li = document.createElement('li');

        // Was discussed that all TH elements are gonna be empty, except the first one
        if (cell.tagName === 'TH') {
          li.classList.add('title');
          if (cellIndex > 0) {
            li.classList.add('hidden');
          }
        }

        li.innerHTML = cell.innerHTML;
        listItems.push(li);
      });
    });

    listItems.forEach(item => listEl.appendChild(item));

    listEl.classList.add('table-list');
    listEl.dataset.columns = String(cellAmount);

    return listEl;
  });

  lists.forEach((list, index) => container.replaceChild(list, tables[index]));

  return container.innerHTML;
};

export const downloadFile = (url, filename) => {
  const element = document.createElement('a');

  element.setAttribute('href', url);
  element.setAttribute('download', filename);
  element.setAttribute('target', '_blank');

  element.dispatchEvent(new MouseEvent('click'));
};

export const toolsNames = {
  adobexd: 'Adobe XD',
  figma: 'Figma',
  sketch: 'Sketch',
  invision: 'Invision',
  protopie: 'Protopie',
  webflow: 'Webflow',
  axure: 'Axure',
  framer: 'Framer',
  marvel: 'Marvel',
  principle: 'Principle',
  miro: 'Miro',
  justinmind: 'Justinmind',
  figjam: 'FigJam',
  jira: 'Jira',
  googledocs: 'Google Docs',
  adobephotoshop: 'Adobe Photoshop',
  adobeillustrator: 'Adobe Illustrator',
  adobefonts: 'Adobe Fonts',
  procreate: 'ProCreate',
  adobeaftereffects: 'Adobe After Effects',
  adobeanimate: 'Adobe Animate',
  autodeskmaya: 'Autodesk Maya',
  unity: 'Unity',
  cinema4d: 'Cinema 4D',
  blender: 'Blender',
  adobedimension: 'Adobe Dimension',
  zbrush: 'ZBrush',
  drawio: 'Draw io',
  zeplin: 'Zeplin',
  claude: 'Claude',
  lovable: 'Lovable',
  gemini: 'Google Gemini',
  stitch: 'Google Stitch',
  aistudio: 'Google AI Studio',
  antigravity: 'Google Antigravity',
  codex: 'Codex',
  canva: 'Canva',
  unreal: 'Unreal Engine',
  aiexpert: 'AI Expert (Claude, Stitch, Antigravity, AI Studio, Lovable)',
  weave: 'Weave AI',
};

export const toolsIcons = {
  adobexd,
  figma,
  sketch,
  invision,
  protopie,
  webflow,
  axure,
  framer,
  marvel,
  principle,
  miro,
  justinmind,
  figjam,
  jira,
  googledocs,
  adobephotoshop,
  adobeillustrator,
  adobeanimate,
  autodeskmaya,
  adobefonts,
  procreate,
  adobeaftereffects,
  unity,
  cinema4d,
  blender,
  adobedimension,
  zbrush,
  drawio,
  zeplin,
  claude,
  lovable,
  gemini,
  stitch,
  aistudio,
  antigravity,
  codex,
  canva,
  unreal,
  aiexpert,
  weave,
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js